import React, { Component } from 'react';
import './MovingAverageGraph.css';
import { t } from 'i18next';

import LineGraph from '../LineGraph/LineGraph';
import TimeSeriesGraph from './TimeSeriesGraph/TimeSeriesGraph';

class MovingAverageGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stdeviation: 1,
    };
    this.handleSTDChange = this.handleSTDChange.bind(this);
  }

  componentDidMount() {
    const { data } = this.props;
    this.formatData(data);
  }

  componentWillReceiveProps(props) {
    const { data } = props;
    this.formatData(data);
  }

  formatData(data) {
    if (data.length !== 1) {
      const rawData = [];
      const timeSeriesData = [];
      const resultData = [];
      data['x-axis'].forEach((value, i) => {
        rawData[i] = {
          x: new Date(data['x-axis'][i]),
          y: data.raw[i],
        };
        timeSeriesData[i] = {
          padding: data.std[i] || 0,
          raw: data.raw[i],
          std: data.result[i],
          x: new Date(data['x-axis'][i]),
          y1: data.transform[i],
          y2: data.mean[i],
        };
        resultData[i] = {
          x: new Date(data['x-axis'][i]),
          y: data.result[i],
        };
      });
      this.setState({
        rawData,
        resultData,
        timeSeriesData,
      });
    }
  }

  handleSTDChange(event) {
    this.setState({
      stdeviation: parseFloat(event.target.value),
    });
  }

  render() {
    const {
      rawData, timeSeriesData, resultData, stdeviation,
    } = this.state;
    const { propertyText = 'Property', normalization, } = this.props;
    return (
      <div className="board">
        {timeSeriesData && (
          <div className="graph-row">
            <div className="graph-row-content">
              <div className="stdField">
                {`${t('tensorAnalytics.graphs.timeSeriesGraph.anomaliesInput')} :`}
                <input type="number"
                  className="devInput"
                  step="0.1"
                  value={stdeviation}
                  onChange={this.handleSTDChange}
                />
              </div>
            </div>
            <div className="graph-row-content">
              <div className="graph-row-title">
                {`${propertyText} ${t('tensorAnalytics.graphs.timeSeriesGraph.timeSeriesTitle')}`}
              </div>
              <TimeSeriesGraph data={timeSeriesData}
                propertyText={propertyText}
                stdeviation={stdeviation}
                yAxisTitle={`${propertyText} ${t('tensorAnalytics.graphs.timeSeriesAxis')}`}
                colors={{
                  anomalyColor: '#ff4a4a',
                  areaColor: '#E5E5FE',
                  meanColor: '#e66000',
                  transformColor: '#D5B98B',
                }}
                labels={{
                  anomalyLabel: t('tensorAnalytics.graphs.timeSeriesGraph.anomalyDetected'),
                  areaLabel: t('tensorAnalytics.graphs.timeSeriesGraph.std'),
                  meanLabel: t('tensorAnalytics.graphs.timeSeriesGraph.mean'),
                  transformLabel: t('tensorAnalytics.graphs.timeSeriesGraph.transform'),
                }}
              />
            </div>
          </div>
        )}
        {resultData && (
          <div className="graph-row">
            <div className="graph-row-content deviation">
              <div className="graph-row-title">
                {`${propertyText} ${t('tensorAnalytics.graphs.movingAverage.title', {
                  normalization
                })}`}
              </div>
              <LineGraph data={resultData}
                textLine={t('tensorAnalytics.graphs.resultLabel')}
                yAxisTitle={`${normalization} ${t('tensorAnalytics.graphs.movingAverage.yAxis')}`}
                colorLine="#A6C3EC"
              />
            </div>
          </div>
        )}
        {rawData && (
          <div className="graph-row">
            <div className="graph-row-content raw">
              <div className="graph-row-title">
                {`${propertyText} ${t('tensorAnalytics.graphs.rawTitle')}`}
              </div>
              <LineGraph data={rawData}
                textLine={t('tensorAnalytics.graphs.rawValue')}
                yAxisTitle={`${propertyText} ${t('tensorAnalytics.graphs.rawValue')}`}
                colorLine="#0074B7"
                xAt0
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default MovingAverageGraph;
